import { type RedirectRequest } from '@azure/msal-browser';

export function getTokenRequest(
  scopes: string[],
  selectAccount: boolean,
  redirectUri?: string,
): RedirectRequest {
  let additionalProperties: Partial<RedirectRequest> = {};
  if (selectAccount) {
    additionalProperties = { prompt: 'select_account' };
  }
  if (redirectUri) {
    additionalProperties.redirectUri = redirectUri;
  }
  return { scopes, ...additionalProperties };
}
